<style lang="less" scoped>
.login{position: absolute;left: 0px;top: 0px;bottom: 0px;right: 0px;background: url('../../../../static/images/zlkindex/background.jpg') no-repeat; background-size: 100% 100%;}
.content{width: 860px; height: 600px; margin: 100px auto;display: flex;}
.left{position: relative;margin-right: 50px;
img{width: 500px;}}
.card{width:300px;height: 250px;border-radius: 10px;margin-top: 80px;}
.header{font-size: 20px;font-weight: 600;height: 34px;margin-left: 20px;color: #355590;}
.el-input{width: 300px;margin-top: 30px;margin-left: 20px;font-size: 18px;}
.el-button{width: 245px;height:35px;margin-top: 30px;margin-left: 35px;background-color: #355590;font-size: 18px;line-height: 13px;}
/deep/.el-input__inner{border:none;border-bottom: 1px solid #ccc;}
.rememberMe{display: flex;justify-content: flex-end;margin: 15px -20px 0 0;}
</style>

<template>
  <div class="login">
    <div class="content">
      <div class="left">
        <h2>中国—东盟矿业信息服务平台后台管理</h2>
        <img src="../../../../static/images/zlkindex/login_image.png" />
      </div>
      <div class="card">
        <div class="header">
          <span>登录账号</span>
        </div>
        <el-input placeholder="用户名" prefix-icon="iconfont icon-zhanghao" v-model="username"></el-input>
        <el-input placeholder="密码" type="password" prefix-icon="iconfont icon-mima" v-model="password" ></el-input>
        <el-checkbox v-model="checked" class="rememberMe">记住账号？</el-checkbox>
        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 后台登录页面
 */
import Encrypt from '../../app/layout/Encrypt'

export default {
  data()
  {
    return {
      username: '',
      password: '',
      checked: false
    }
  },
  watch: {
    'checked': function(newVal)
    {
      this.saveLogin()
    }
  },
  created()
  {
    this.loadSavedLogin()
  },
  methods:
  {
    /**
     * 字符串转字节数组
     * @static
     * @method
     * @param   {String}    str               字符串
     * @returns {Array.<byte>}                返回字节数组
     */
    strToBytes(str)
    {
      const bytes = []
     
      for (let i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i))
     
      return bytes
    },
    /**
      * 字节数组转字符串
      * @static
      * @method
      * @param   {String}    bytes             字节数组
      * @returns {Array.<byte>}                返回字节数组
      */
    bytesToStr(bytes)
    {
      const str = []
        
      for (let i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]))
        
      return str.join('')
    },
    loadSavedLogin()
    {
      this.username = localStorage.getItem('username') || ''
      this.password = localStorage.getItem('password') || ''
      if (this.username && this.password)
      
        this.checked = true
    },
    async login()
    {
      if (this.username === 'admin')
        this.jitAuthen()
      else
        this.loginDefault()
    },
    loginDefault()
    {
      let params = {
        cmd: 'login',
        username: Encrypt.encrypt(this.username, this.bytesToStr(this.strToBytes(window.loginKey))),
        password: Encrypt.encrypt(this.password, this.bytesToStr(this.strToBytes(window.loginKey))),
        type: 1,
        sys: 11
      }
      window.post.getLogin(params).then(ret =>
      {
        if (ret.ret === 1)
          this.$message({message: '登录失败', type: 'error', customClass: 'mzindex'})
        else
        {
          cx.http.setAuth(ret.Authorization)
          localStorage.setItem('auth', ret.Authorization)
          sessionStorage.setItem('auth', ret.Authorization)
          this.$message({message: '登录成功', type: 'success', customClass: 'mzindex'})
          let userInfo = JSON.stringify(ret)
          localStorage.setItem('userMsg', userInfo)
          sessionStorage.setItem('userMsg', userInfo)

          let userRole = JSON.parse(sessionStorage.getItem('userMsg')).role
          if (userRole === 5)
            this.$router.push({path: '/Qyzsgl'})
          else
            this.$router.push({path: '/HTIndex'})
        }
      }).catch(e =>
      {
        console.log(e)
      })
    },

    jitAuthen()
    {
      //1发起随机数请求
      let random = JIT_AUTHEN.random()
      if (random !== '')
      {
        // 2对随机数做p7签名
        let P7SignResutl = JIT_AUTHEN.AuthP7Sign(random)
        if (P7SignResutl !== '')
        {
          //3请求网关认证
          let authResult = JIT_AUTHEN.P7certAuth(random, P7SignResutl)
          let contextForm = JSON.stringify(authResult)
          localStorage.setItem('contextForm', contextForm)
          this.loginDefault()
        }
      }
      else
        alert('随机数获取失败！')
    },

    saveLogin()
    {
      if (this.checked)
      {
        localStorage.setItem('username', this.username)
        localStorage.setItem('password', this.password)
      }
      else
      {
        localStorage.removeItem('username')
        localStorage.removeItem('password')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/login/loginHT.vue